import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  
  constructor(private loader: LoaderService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const skipLoader = req.headers.has('X-Skip-Loader');
    const request = skipLoader
      ? req.clone({ headers: req.headers.delete('X-Skip-Loader') })
      : req;
    
    // Add header to identify admin console
    const clonedReq = request.clone({
      setHeaders: {
        'X-Client-Type': 'AdminConsole'
      }
    });

    if (skipLoader) {
      return next.handle(clonedReq);
    }

    this.loader.showLoader();
    
    return next.handle(clonedReq).pipe(
      finalize(() => this.loader.hideLoader())
    );
  }
}
